import getBasePath from '../functions/api-resource';
import resourceBuilder from '../functions/metadados-resource-builder';

const basePath = getBasePath('apuracao_acao', 'contrato');

const apuracaoActions = {
  concluir: { method: 'PUT', url: `${basePath}{/idContrato}/acao/{idAcao}/apuracao{/idApuracao}/concluir` },
  buscarDataApuracaoAcaoPorStatus: { method: 'GET', url: `${basePath}{/idContrato}/status/{status}/datas` },
  buscarApuracaoFinalizar: { method: 'GET', url: `${basePath}/apuracao/{idApuracao}/finalizar` },
  buscarRealizadoDetalhamento: { method: 'GET', url: `${basePath}/realizado-detalhamento/{idApuracao}` },
  buscarNDsGeradas: { method: 'GET', url: `${basePath}/nds-geradas/{idApuracao}` },
};

export default (resource) => resource(`${basePath}`, {}, apuracaoActions);

export const buscarApuracaoFornecedorPorContrato = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'fornecedor/apuracoes', parametros).doGet();

export const finalizarApuracaoLoteFornecedor = (parametros, resource) => resourceBuilder.buildPUT(resource, basePath, 'finalizar/fornecedor', parametros).doPut(parametros);

export const buscarDetalhesApuracaoContrato = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'fornecedor/apuracoes/detalhes', parametros).doGet();

export const salvarApuracaoDataContabilizacao = (parametros, resource) => resourceBuilder.buildPUT(resource, basePath, 'salvar-acao-data-contabilizacao', parametros).doPut(parametros);

export const buscarTotalizadoresPeriodoApuracao = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'totalizadores/periodo-apuracao', parametros).doGet();

export const buscarRealizadoDetalhamentoCategoriaAgrupada = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'realizado-detalhamento-categoria-agrupada', parametros).doGet();

export const buscarFamiliasSelecionadas = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'buscar-familias-selecionadas', parametros).doGet();

export const buscarFornecedorPagador = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'fornecedor/pagador', parametros).doGet();

export const salvarApuracaoInformacoesNotaDebito = (parametros, resource) => resourceBuilder.buildPOST(resource, basePath, 'salvar-apuracao-informacoes-nota-debito', parametros).doPost(parametros);

export const buscarAcaoExternaFornecedor = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'buscar-acao-externa', parametros).doGet();

export const salvarAcaoExternaFornecedor = (parametros, resource) => resourceBuilder.buildPUT(resource, basePath, 'salvar-acao-externa', parametros).doPut(parametros);
